function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

function sqListView() {
  const app = document.querySelector(".sparq-container");
  app.classList.add("--list-view");
}

window.sq = window.sq || {};

window.sq.initSearch = (store) => {
  store.search();
};

(function (XHR) {
    "use strict";

    var originalOpen = XHR.prototype.open;
    var originalSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url, async, user, pass) {
        this._url = url; // Save the URL for later use
        originalOpen.call(this, method, url, async, user, pass);
    };

    XHR.prototype.send = function (data) {
        var url = this._url;
        let location = window.location.href;
        
        if (url.toLowerCase() === "https://7ilas8um8a85fpvgarfl5n4m.fast.sparq.ai/v2".toLowerCase()) {
            let body;
            try {
                body = JSON.parse(data);
            } catch (error) {
                console.error("Error parsing XHR data as JSON:", error);
                // If parsing fails, just proceed to send the original data
                originalSend.call(this, data);
                return;
            }

            // Extract collection handle from URL if present
            let collectionHandle = location.includes("/collections/") ? location.split("/collections/")[1].split("?")[0] : null;

            // Proceed only if we're not on a search or all page and collectionHandle is found
            if (!location.includes("/search") && !location.includes("/all") && collectionHandle) {
                let collectionHandleFormatted = `sortOrderFor_${collectionHandle.replaceAll("-", "_")}`;
                let sorting = body.sort || [];

                // Add collection-specific sortOrder if not already included
                if (!sorting.includes(collectionHandleFormatted)) {
                    sorting.push(collectionHandleFormatted);
                }

                // Update the sort order
                body.sort = sorting;

                // Convert the modified body back to a JSON string
                data = JSON.stringify(body);
            }
        }

        // Proceed to send the (possibly modified) data
        originalSend.call(this, data);
    };
})(XMLHttpRequest);

setTimeout(() => {
  if (document.querySelector(".sq-filter-main"))
    document.querySelector(".sq-filter-main").style.visibility = null;
  if (document.querySelector(".sparq-container"))
    document.querySelector(".sparq-container").style.visibility = null;
  if (document.querySelector(".sq-app.sq-dropdown"))
    document.querySelector(".sq-app.sq-dropdown").style.visibility = null;
}, 800);

window.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    document.querySelector("footer").click();
  }
});

setTimeout(() => {
  if (location.href.includes("/search?q=")) {
    let url = new URL(location.href);
    let params = new URLSearchParams(url.search);
    let q = params.get("q"); // 'mdn query string'
    document.querySelector("#search2").value = q;
  }
}, 200);

window.sq.hidePagination = function (store) {
  setTimeout(() => {
    const sparqContainer = document.querySelector(".sparq-container");
    document.querySelectorAll(".sparq-container form").forEach((e) => {
      theme.AddItemToCart(e);
    });

    if (sparqContainer && store.currentPage == 1) {
      sparqContainer.classList.add("sq-hide-prev");
    } else {
      sparqContainer.classList.remove("sq-hide-prev");
    }

    if (store.currentPage === store.totalPages) {
      sparqContainer.classList.add("sq-hide-next");
    } else {
      sparqContainer.classList.remove("sq-hide-next");
    }
  }, 200);

  return true;
};

setTimeout(() => {
  const listBtn = document.querySelector('[aria-label="List"]');
  const gridBtn = document.querySelector('[aria-label="Grid"]');
  // const sqSort = document.querySelector(".sq-sort");

  if (!listBtn) return;
  listBtn.addEventListener("click", () => {
    const app = document.querySelector(".sparq-container");
    app.classList.add("--list-view");
    app.classList.remove("--grid-view");
  });
  gridBtn.addEventListener("click", () => {
    const app = document.querySelector(".sparq-container");
    app.classList.remove("--list-view");
    app.classList.add("--grid-view");
  });
  if (listBtn.classList.contains("is-selected")) listBtn.click();
  if (gridBtn.classList.contains("is-selected")) gridBtn.click();
  // listBtn.append(sqSort);
}, 500);

window.sq.loadImage = function (item) {
  const sparqCard = document.querySelector(
    `.sparq-card[product-handle="${item.handle}"]`
  );
  setTimeout(() => {
    sparqCard
      .querySelector(".sparq-thumbnail-wrap")
      .classList.remove("zoom-fade-animation");
  }, 500);
};


window.sq.setBrandURL = function (item) {
  const collection = location.pathname.split("/");
  let url = `${location.origin}/collections/${
    collection[collection.length - 1]
  }?system_vendor=${item.vendor}`;
  // let url = `${location.origin}/collections/${collection[collection.length-1]}?system_vendor=${item.vendor}&sort=sortOrderFor_${collection[collection.length-1].replaceAll("-","_")}`;
  if (location.href.includes("/search")) {
    url = `${location.origin}/collections/all?system_vendor=${item.vendor}`;
  }
  return url;
};

setTimeout(() => {
  document.querySelector('[name="q"]').addEventListener("keydown", (e) => {
    if (e.keyCode === 13) {
      console.log("Enter key pressed!");
      e.stopPropagation();
      e.preventDefault();
      location.href = location.origin + "/search?q=" + e.target.value;
    }
    toggleDropdown();
  });
}, 200);

function toggleDropdown() {
  setTimeout(() => {
    if (document.querySelector('[name="q"]').value.length > 0) {
      document.querySelector(".sq-app.sq-dropdown").style.display = null;
    } else {
      document.querySelector(".sq-app.sq-dropdown").style.display = "none";
    }
  }, 200);
}

window.sq.updatePrice = function (searchResults) {
  const fetchData = searchResults.results.map((r) => {
    return fetch(`/products/${r.handle}.js`)
      .then((res) => res.json())
      .then((d) => {
        // Assuming you want the price of the first variant
        const variant = d.variants[0];
        r.price = parseFloat(variant.price) / 100; // Shopify returns price in cents
        r.compare_at_price = parseFloat(variant.compare_at_price) / 100 || null;
        changePrice(r);
      })
      .catch((e) => {
        console.error(`Failed to fetch data for ${r.handle}: ${e}`);
      });
  });
  return searchResults.results;
};

function changePrice(item) {
  const sparqCard = document.querySelector(
    `.sparq-card[product-handle="${item.handle}"]`
  );

  const priceElement = sparqCard.querySelector(".sq-price");
  const comparePriceElement = sparqCard.querySelector(".sq-compare-price");

  if (priceElement) {
    priceElement.classList.add("loaded");
    priceElement.innerHTML = item.price.toLocaleString("en-US", {
      style: "currency",
      currency:
        Shopify.currency.active == "CAD" ? "USD" : Shopify.currency.active,
    });
  }

  if (comparePriceElement && item.compare_at_price) {
    comparePriceElement.classList.add("loaded");
    comparePriceElement.innerHTML = item.compare_at_price.toLocaleString(
      "en-US",
      {
        style: "currency",
        currency: "USD",
      }
    );
  }

  if (
    item.compare_at_price &&
    item.compare_at_price > item.price &&
    typeof sqSave !== "undefined" &&
    typeof notLoyalityTag !== "undefined"
  ) {
    sqSave.innerHTML = `(You save ${(
      item.compare_at_price - item.price
    ).toLocaleString("en-US", { style: "currency", currency: "USD" })})`;
    notLoyalityTag.style.display = "block";
  }
}
